export default function FelaThemeFactory(createElement, ThemeContext) {
  function FelaTheme(_ref) {
    var children = _ref.children;

    var renderFn = children;

    return createElement(ThemeContext.Consumer, undefined, renderFn);
  }

  return FelaTheme;
}